<template>
  <li class="flex py-4 border-b-2 border-background last:border-none">
    <figure class="w-[86px] h-[68px] md:w-[116px] md:h-[90px] rounded-[5px] image-overlay-gray overflow-hidden mr-4 shrink-0">
      <img
        v-if="product.image"
        loading="lazy"
        :src="getImage(product.image)"
        :alt="product.image.name"
        class="w-full h-full object-contain"
      />
    </figure>

    <div class="w-full">
      <div class="text--md mb-2 xl:text-gray">
        {{ product.fullName }}
      </div>
      <div
        v-if="product.price"
        class="text--btn mb-4 flex justify-between md:flex-col md:gap-2"
        :class="{
          'text-rose': theme === 'kids',
          'text-primary': theme === 'default',
        }"
      >
        <div>
          <span>{{ product.price.value }} </span>
          <span>{{ product.price.currencyIso }}</span>
        </div>
        <div v-if="theme === 'default'" class="flex gap-[20px] justify-end md:justify-start xl:ml-6">
          <span class="text-yellow flex gap-[3px]"
            ><icon-rating />
            <span class="font-bold text-[14px]">{{ product.rating || 5 }}</span>
          </span>

          <span class="text-gray hidden md:inline font-normal"> {{ product.reviews || 0 }} reviews </span>
        </div>
      </div>
      <div v-else class="text--btn text-white bg-gray mb-4 py-1 px-2 rounded-[5px] max-w-max">
        <span>no offers</span>
      </div>
      <button
        @click="goToProduct"
        class="py-[11.5px] max-w-[280px] md:w-[200px] md:py-5 md:px-0 px-4"
        :class="{
          'btn--primary': theme === 'kids',
          'btn--blue': theme === 'default',
        }"
      >
        {{ $t("common.view-offers", { count: product.offerCount }) }}
      </button>
    </div>
  </li>
</template>

<script setup>
import { getImage } from "@/services/getImage"
import { theme } from "@/services/getSiteTheme"
import { useRouter } from "vue-router"

const props = defineProps({
  product: {
    type: Object,
    default() {
      return {}
    },
  },
})

const emit = defineEmits({
  "close-list": null,
})

const router = useRouter()

const goToProduct = () => {
  router.push({
    name: "/product/sku",
    params: { sku: props.product.sku },
  })
  emit("close-list")
}
</script>

<style lang="scss" scoped></style>
